import { Plugin } from '@ckeditor/ckeditor5-core';
import ImagesUi from './imagesui';

export default class Tooltip extends Plugin {
    static get requires() {
        return [ ImagesUi ];
    }
}
